import { patientIdSchema, questionnaireInstanceIdSchema } from "@repo/api/schemas";
import { useQuestionnaireInstance, useQuestionnaireScores } from "@repo/data-store";
import { createFileRoute } from "@tanstack/react-router";
import { QuestionnaireResponseDetail } from "@/features/questionnaire-responses";

export const Route = createFileRoute("/patients/$patientId/_layout/assessments/q/$instanceId")({
  component: RouteComponent,
});

function RouteComponent() {
  const instanceId = questionnaireInstanceIdSchema.parse(Route.useParams().instanceId);
  const response = useQuestionnaireInstance(instanceId);
  const scores = useQuestionnaireScores(patientIdSchema.parse(Route.useParams().patientId), instanceId);

  if (!response) {
    return <div className="p-6 text-sm text-muted-foreground">Questionnaire not found.</div>;
  }

  return <QuestionnaireResponseDetail response={response} scores={scores} />;
}
